import { Component } from '@angular/core';
import { AbstractFormComponent } from '@app/shared/common/abstract.component';
import { FormBuilder, Validators } from '@angular/forms';
import { routerTransition } from '@app/router.animations';

@Component({
  selector: 'app-sample',
  templateUrl: './sample.component.html',
  animations: [routerTransition()],
  host: { '[@routerTransition]': '' }
})
export class SampleComponent extends AbstractFormComponent {
  constructor(private formBuilder: FormBuilder) {
    super();
    this.form = this.formBuilder.group({
      question: ["", Validators.required]
    });
  }

  onSubmit() {
    super.onSubmit();
  }
  handlerInKey(key) {
    //console.log(key);
  }
}



// WEBPACK FOOTER //
// ./src/app/features/sample/sample.component.ts